import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

GSAP.registerPlugin(ScrollTrigger)

export default class Nav {
	constructor() {
		
		this.logo						= document.querySelector(".site-logo")
		this.returnToNavState 			= this.returnToNavState.bind(this)
		this.clickMenuButton 			= this.clickMenuButton.bind(this)
		this.getNavState 				= this.getNavState.bind(this)
		this.closeOtherMenus			= this.closeOtherMenus.bind(this)
		this.openNav 					= this.openNav.bind(this)
		this.closeNav 					= this.closeNav.bind(this)
		this.navStartState				= 'nav--dark'
		this.navOpen					= false
		this.mainMenu					= document.getElementById('menu')
		this.locationsMenu				= document.getElementById('locations')
		this.proxyLogo 					= { top: '40vh', width: '30vw' }

		// GET ALL MENUS
		this.menus 						= document.querySelectorAll("[data-menu]");
		this.menuButtons 				= document.querySelectorAll("[data-nav]");

		// HANDLE CLICKS
		this.menuButtons && this.menuButtons.forEach((menuButton)=>{
			menuButton.addEventListener('click', this.clickMenuButton )
		})

		this.logoSpin()
		this.sticky()
		
	}
	clickMenuButton(event) {

		const menuName 		= event.target.dataset.nav;
		const menu 			= document.getElementById(menuName);

		if(menu){
			// IF THIS MENU IS OPEN
			if( menu.classList.contains('menu--open') ){

				this.closeMenu(menu,menuName)
				// ONLY WHEN A NAV IS FINALLY CLOSED AND RETURNED TO PAGE, DO WE RETURN TO ORIGINAL NAV STATE
				this.returnToNavState(this.navStartState)

				// THE WHOLE NAV IS CLOSED
				this.closeNav()
			} 
			else // IF THIS MENU IS CLOSED
			{
				this.closeOtherMenus(menu,this.menus)
				// BEFORE OPENING MENU, SET THE NAV START STATE
				if(this.navOpen){
					
				} else {
					this.getNavState()
					this.openNav()
				}
				// console.log(`this is the navStartState in scope of button: ${this.navStartState}`)
				this.openMenu(menu,menuName)
			}
		}

		// MAKE BUTTONS ACTIVE
		event.target.classList.toggle('btn--active')
		event.target.classList.toggle('pill--active')

	}
	closeOtherMenus(exceptThis,siblings) {
		for (var i = 0; i < siblings.length; i++) {
			if (siblings[i] !== exceptThis) {
				siblings[i].classList.remove("menu--open");
				// console.log(`close other menus`)
				this.changeButtonStates(siblings[i].id);
				const menuName 	= siblings[i].dataset.menu;
				window.document.body.classList.remove(`nav--${menuName}`)
			}
		}
	}
	changeButtonStates(menu){
		const buttons = window.app.nav.querySelectorAll(`[data-nav="${menu}"]`)
		buttons.forEach((button)=>{
			button.classList.remove('btn--active')
			button.classList.remove('pill--active')
		})
	}
	openMenu(menu, menuName)
	{
		menu.classList.add('menu--open')
		window.document.body.classList.add(`nav--${menuName}`)
		if(menuName === 'menu'){
			window.document.body.classList.add('nav--light')
		}
		if(menuName === 'locations'){
			window.document.body.classList.remove('nav--light')
		}
		window.app.smoothScroll.lenis && window.app.smoothScroll.lenis.stop()
	}
	closeMenu(menu, menuName)
	{
		menu.classList.remove('menu--open')
		window.document.body.classList.remove(`nav--${menuName}`)
		window.app.smoothScroll.lenis && window.app.smoothScroll.lenis.start()
	}
	getNavState(){
		let body = document.querySelector('body')
		if(body.classList.contains('nav--light')){
			this.navStartState = 'nav--light'
		} else {
			this.navStartState = 'nav--dark'
		}
	}
	returnToNavState(navStartState){
		if(navStartState == 'nav--dark'){
			window.document.body.classList.remove('nav--light')
		} 
		if(navStartState == 'nav--light'){
			window.document.body.classList.add('nav--light')
		}
	}
	sticky()
	{

		// HIDING NAV ON SCROLL USING GSAP

		this.showNavAnimation = GSAP.from(window.app.nav, { 
			yPercent: -110,
			paused: true,
			duration: 0.1
		}).progress(1);

		if( document.body.classList.contains('home') || 
			document.body.classList.contains('single-locations') ){
			this.scrollHideStartDistance = window.innerHeight + ' top'
		} else {
			this.scrollHideStartDistance = '100px top'
		}

		ScrollTrigger.create({
			start: this.scrollHideStartDistance,
			end: 999999,
			onUpdate: (self) => {
				if( self.direction === -1 ){
					this.showNavAnimation.play()
				} else {
					this.showNavAnimation.reverse()
				}
			}
		});

	}
	logoSpin()
	{

		GSAP.set(this.logo, {
			yPercent: -50,
			xPercent: -50,
		})

		if( document.body.classList.contains('home') ){

			this.logoIntroductionAnim = GSAP.timeline({
			}).from(this.logo,{
				top: '50vh',
				width: '30vw',
				scrollTrigger:{
					trigger: ".hero",
					scrub:0,
					start: 'top top',
					end: "bottom top"
				},
				onUpdate: () => {
					if(this.navOpen == false) {
						this.proxyLogo.top = this.logo.style.top;
						this.proxyLogo.width = this.logo.style.width;
					}
				}
			}).to(this.logo, {
				rotation:360*5,
				duration:1, 
				ease:'none',
				scrollTrigger:{
					trigger: "body",
					scrub:0.2,
					start: 'top top',
					end:'+=10000',
				}
			},'<')

		} else {

			let rotate = GSAP.timeline({
				scrollTrigger:{
					trigger: "body",
					scrub:0.2,
					start: 'top top',
					end:'+=10000',
				}
			})
			.to(this.logo, {
				rotation:360*5,
				duration:1, 
				ease:'none',
			})

		}

	}
	openNav() {
		window.document.body.classList.add("nav--active")
		this.navOpen = true

		if( document.body.classList.contains('home') ){

			GSAP.to(this.logo, { 
				// top: '-33px', 
				top: '5px',
				width: '120px',
				overwrite: 'auto',
				duration: 0.01,
			});
			
		}

	}
	closeNav(){
		window.document.body.classList.remove("nav--active")
		this.navOpen = false
		if( document.body.classList.contains('home') ){

			GSAP.to(this.logo, { 
				top: this.proxyLogo.top, 
				width: this.proxyLogo.width,
				overwrite: 'auto',
				duration: 0.01,
			});

		}

	}
}
